module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/064-lithuania-36777a49d50a225599c3fb0bb125a6b1.svg";